<template>
  <div>
    <p class="team-header">Redemption Page</p>
    <!--  Logo Here -->
    <div class="row-logo">
      <div class="tip-holder">
        <p class="logo-label">Logo</p>

        <ToolTipInfo
          :popOverContent="logoTooltip"
          :popOverPosition="tooltipPosition"
          icon="i"
        />
      </div>

      <div class="logo-section">
        <div class="portrait">
          <img
            :src="!logo ? noImage : logo"
            :class="{ padded: Object.keys(team.teamLogo).length }"
          />
        </div>
        <label for="logo-upload" class="custom-file-upload">
          Upload
        </label>
        <label
          class="custom-file-upload"
          v-if="Object.keys(team.teamLogo).length"
          @click="removeLogo"
        >
          Remove Logo
        </label>
        <input
          id="logo-upload"
          type="file"
          :accept="accept"
          @change="uploadLogo"
        />
      </div>
    </div>

    <!-- Redemption Page Logo Here -->
    <div class="row-logo redemption ">
      <div class="tip-holder">
        <p class="logo-label">Background Photo</p>

        <ToolTipInfo
          :popOverContent="backgroundTooltip"
          :popOverPosition="tooltipPosition"
          icon="i"
        />
      </div>
      <div class="logo-section relative">
        <div class="portrait redemption">
          <img
            :src="!backgroundImage ? noBackground : backgroundImage"
            class="redemption"
          />
        </div>

        <label for="redemption-upload" class="custom-file-upload">
          Upload
        </label>

        <label
          class="custom-file-upload"
          v-if="Object.keys(this.team.teamCustomBackground).length"
          @click="removeBackground"
        >
          Remove Background
        </label>

        <input
          id="redemption-upload"
          type="file"
          :accept="accept"
          @change="handleUpload($event)"
        />

        <ImageCropper
          :image="image"
          :isOpen="isCropTool"
          aspect-ratio="9 / 16"
          @closeModal="isCropTool = false"
          @crop="file => uploadBackground(file)"
        />

        <p class="absolute max-upload">Maximum upload file size: 5MB</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { defaultNotFoundImage, noBackground } from '../../helpers'
import i18n from '../../internatinalization/i18n'
import ToolTipInfo from '@/components/Universal/ToolTipInfo.vue'
import ImageCropper from '@/components/Universal/ImageCropper'

let bodyFormData = new FormData()

export default {
  name: 'RedemptionOptions',
  components: { ToolTipInfo, ImageCropper },

  data: () => ({
    image: null,
    isCropTool: false,
    logo: '',
    backgroundImage: '',
    noImage: defaultNotFoundImage,
    noBackground: noBackground,
    accept: 'image/jpeg,image/gif,image/png,application/pdf,image/x-eps'
  }),

  computed: {
    ...mapState({
      team: state => state.team.team
    }),

    logoTooltip() {
      return `For best results, we recommend uploading image with Aspect Ratio 1:1.`
    },

    backgroundTooltip() {
      return `Maximum file size supported: 5MB. \n
      For best results, we recommend uploading image with Aspect Ratio 9:16.`
    },

    tooltipPosition() {
      if (this.innerWidth < 1000) {
        return 'bottom-start'
      }
      return 'right'
    }
  },

  mounted() {
    this.handleImages()
  },

  methods: {
    handleUpload(event) {
      this.image = event
      this.isCropTool = true
    },

    handleImages() {
      if (this.team.hideLogo) {
        this.logo = this.noImage
      } else {
        this.logo = Object.keys(this.team.teamLogo).length
          ? this.team.teamLogo.url
          : this.noImage
      }
      if (this.team.hideBackground) {
        this.backgroundImage = this.noBackground
      } else {
        this.backgroundImage = Object.keys(this.team.teamCustomBackground)
          .length
          ? this.team.teamCustomBackground.url
          : this.noBackground
      }
    },
    uploadLogo(e) {
      if (e.target.files.length > 0) {
        let size = e.target.files[0].size
        size = Math.round(size / 1024)
        if (size >= 2048) {
          this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [i18n.t('validations.image-size-2MB-exceeded')]
          })
          return
        }
        this.logo = URL.createObjectURL(e.target.files[0])
        bodyFormData.delete('team[custom_background]')
        bodyFormData.delete('team[custom_logo]')
        bodyFormData.delete('team[hide_background]')
        bodyFormData.delete('team[hide_logo]')

        bodyFormData.append('team[hide_logo]', false)
        bodyFormData.append('team[custom_logo]', e.target.files[0])
        this.$store.dispatch('team/uploadTeamLogoAndBackground', {
          storeData: bodyFormData,
          removeImageAction: false
        })
      }
    },

    uploadBackground(file) {
      this.image = null
      this.backgroundImage = URL.createObjectURL(file)
      bodyFormData.delete('team[custom_background]')
      bodyFormData.delete('team[hide_background]')
      bodyFormData.delete('team[hide_logo]')
      bodyFormData.delete('team[custom_logo]')

      bodyFormData.append('team[custom_background]', file)
      bodyFormData.append('team[hide_background]', false)
      this.$store.dispatch('team/uploadTeamLogoAndBackground', {
        storeData: bodyFormData,
        removeImageAction: false
      })
    },
    async removeLogo() {
      bodyFormData.delete('team[hide_logo]')
      bodyFormData.delete('team[hide_background]')
      bodyFormData.delete('team[custom_background]')
      bodyFormData.delete('team[custom_logo]')
      bodyFormData.append('team[hide_logo]', true)
      await this.$store.dispatch('team/uploadTeamLogoAndBackground', {
        storeData: bodyFormData,
        removeImageAction: true,
        updateType: 'logo'
      })
      this.handleImages()
    },
    async removeBackground() {
      bodyFormData.delete('team[hide_background]')
      bodyFormData.delete('team[hide_logo]')
      bodyFormData.delete('team[custom_background]')
      bodyFormData.delete('team[custom_logo]')
      bodyFormData.append('team[hide_background]', true)
      await this.$store.dispatch('team/uploadTeamLogoAndBackground', {
        storeData: bodyFormData,
        removeImageAction: true,
        updateType: 'background'
      })
      this.handleImages()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.row-logo {
  display: flex;
  height: auto;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 2rem;

  &.redemption {
    margin: 4rem 0;
  }

  .logo-label {
    text-align: left;
    font-size: 0.813rem;
    font-weight: 700;
    margin-top: 2px;
  }

  .logo-section {
    display: flex;
    align-items: flex-end;
    gap: 1.2rem;
  }
}

.max-upload {
  color: #a09c95;
  font-size: 0.563rem;
  bottom: -20px;
}

.team-header {
  font-size: 1rem;
  font-weight: 400;
  text-align: left;
  margin-bottom: 2.5rem;
  font-family: $editorial;
}

.custom-file-upload {
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
  font-size: $content-font-size;
  color: $main-6;
}

.portrait {
  width: 67px;
  height: 65px;
  display: flex;
  justify-content: center;
  border: 1px solid $tab-ative;
  background: white;

  &.redemption {
    width: 179px;
    height: 154px;
    border: none;
    background: inherit;
  }

  img {
    object-fit: contain;
    margin: auto;
    width: 100%;
    height: 100%;

    &.redemption {
      object-fit: cover;
    }

    &.padded {
      padding: 10px;
    }
  }
}

.tip-holder {
  display: flex;
  align-items: center;
  width: 20%;

  span {
    margin-left: 8px;
    margin-bottom: 2px;
  }
}
</style>
